import HttpService from "./http.service";
import { getRefreshToken } from "./authTokens";

class AuthService {
  login = async (payload) => {
    const loginEndpoint = "login";
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = "register";
    return await HttpService.post(registerEndpoint, credentials);
  };

  verifyEmail = async (token) => {
    const verifyEmailEndpoint = `verify-email?token=${token}`; // Construct the endpoint URL with the token
    return await HttpService.get(verifyEmailEndpoint);
  };
  
  // Sends the refresh token so the server ends this session too
  logout = async () => {
    const logoutEndpoint = "logout";
    return await HttpService.post(logoutEndpoint, { refresh_token: getRefreshToken() });
  };

  forgotPassword = async (payload) => {
    const forgotPassword = "password-forgot";
    return await HttpService.post(forgotPassword, payload);
  };

  resendEmail = async (payload) => {
    const endpoint = "resend-email";
    return await HttpService.post(endpoint, payload);
  };

  // Public: SMS setup short code -> { data: { attributes: { token, email, expires_at } } }
  resolveSetupLink = async (code) => {
    const endpoint = "setup-links/resolve";
    return await HttpService.post(endpoint, { code });
  };

  resetPassword = async (credentials) => {
    const resetPassword = "password-reset";
    return await HttpService.post(resetPassword, credentials);
  };

  getProfile = async () => {
    const getProfile = "me?include=Role";
    return await HttpService.get(getProfile);
  };

  updateProfile = async (newInfo) => {
    const updateProfile = "me";
    return await HttpService.patch(updateProfile, newInfo);
  };
}

export default new AuthService();
